module.exports = __webpack_public_path__ + "static/media/fig_13c.e455f410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13c.jpg
// module id = 636
// module chunks = 0